const tokenPattern = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export function memberCardTokenFromQr(value: string, staffOrigin: string): string | null {
  let token = value;
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) {
    try {
      const url = new URL(value);
      if (url.origin !== staffOrigin || url.pathname !== '/members/scan' || url.search) return null;
      if (!url.hash.startsWith('#card=')) return null;
      token = decodeURIComponent(url.hash.slice('#card='.length));
    } catch {
      return null;
    }
  }
  return token.length <= 2048 && tokenPattern.test(token) ? token : null;
}
